/* eslint-disable new-cap */
import React, { useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import { useLang } from "~/hooks/useLang";
import { Downgraded, useHookstate } from "@hookstate/core";
import { getDevicesConnectedByDispatchGroups, getDevicesConnectedByType } from "./services";
import ColumnChartHorizontal from "~/components/ColumnChartMui/HorizontalChart";
import PieChartMui from "~/components/PieChartMui";

type ResponseProps = ReadonlyArray<{
  readonly item: string
  readonly value: number
}>


export default function DeviceConnectedByDispatchGroups({ loading,
  deviceId,
  dispatchGroupId,
  refresh,
  groupSetId,
  operationUnitId,
  expandFilterSearch,
  agencyId,
  searched,
  // dateStart,
  // dateFinish,
}) {
  const { translate } = useLang()
  const devicesConnectedData = useHookstate<ResponseProps>([]);
  const totalDevicesConnected = useHookstate<number | null>(null);
  const devicesConnecteByTypedData = useHookstate<ResponseProps>([]);
  const totalDevicesConnectedByType = useHookstate<number | null>(null);


  useEffect(() => {
    loading.set(true)
    totalDevicesConnectedByType.set(null)
    totalDevicesConnected.set(null)
    getDevicesConnectedByDispatchGroups({
      deviceId: deviceId,
      dispatchGroupIds: dispatchGroupId,
      groupSetId: groupSetId,
      operationUnitId: operationUnitId,
      agencyId: agencyId
      // finishDate: dateFinish,
      // startDate: dateStart,
    }).then((response) => {
      const result = response.map((responseData) => {
        totalDevicesConnected.set(totalDevicesConnected.get() + responseData.total)
        return { item: responseData.name, value: responseData.total }
      })
      return devicesConnectedData.set(result)
    }).finally(() => {
      loading.set(false)
    })

    getDevicesConnectedByType({
      deviceId: deviceId,
      dispatchGroupIds: dispatchGroupId,
      groupSetId: groupSetId,
      operationUnitId: operationUnitId,
      agencyId: agencyId
      // finishDate: dateFinish,
      // startDate: dateStart,
    }).then((response) => {

      const result = response.map((responseData, index) => {
        totalDevicesConnectedByType.set(totalDevicesConnectedByType.get() + responseData.total)
        return { id: index, label: responseData.name, value: responseData.total, total: responseData.total }
      })
      return devicesConnecteByTypedData.set(result)
    }).finally(() => {
      loading.set(false)
    })


  }, [refresh])

  useEffect(() => {
      if (!searched) {
        devicesConnectedData.set([])
        devicesConnecteByTypedData.set([])
      }
  }, [searched])
  

  return (
    <Grid container xs={12} sx={{ display: 'flex', paddingX: 3, paddingTop: 3, justifyContent: 'space-between' }}>
      <Grid item xs={12} hidden={!expandFilterSearch} paddingBottom={1}>
        <Typography sx={{ fontWeight: 'bold', fontSize: 16 }}>
          {translate('Devices by dispatch group and by type')}
        </Typography>
      </Grid>
      <Grid item xs={6} hidden={!expandFilterSearch} paddingRight={1}>
        <ColumnChartHorizontal
          data={devicesConnectedData.attach(Downgraded).get()}
          title={`Devices by dispatch groups`}
          subtitle={`${translate('Total devices')}: ${Intl.NumberFormat("pt-BR").format(Number(totalDevicesConnected.get()))}`}
          typeTotal={'Dispatchs Groups'}
        />
      </Grid>
      <Grid item xs={6} hidden={!expandFilterSearch}>
        <PieChartMui
          data={devicesConnecteByTypedData.attach(Downgraded).get()}
          title={'Devices connected by type'}
          subtitle={`${translate('Total devices')}: ${Intl.NumberFormat("pt-BR").format(Number(totalDevicesConnectedByType.get()))}`}
          typeTotal={'Device Type'}
          showPercent
        />
      </Grid>
    </Grid>
  )
}